import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
  Renderer2,
  Component,
  HostBinding,
} from '@angular/core';

@Component({
  selector: '[pmdAccordion]',
  exportAs: 'pmdAccordion',
  template: '<ng-content></ng-content>',
  standalone: false,
})
export class PmdCollapseAccordion {
  @Input() closeOthers: boolean;
  public groups: PmdCollapse[] = [];
  constructor() {}
}

@Directive({
  selector: '[pmdCollapse]',
  exportAs: 'pmd-collapse',
  host: {
    '[class.collapse]': 'true',
  },
  standalone: false,
})
export class PmdCollapse implements OnInit, OnDestroy {
  @Output('onShow') public onShow: EventEmitter<any> = new EventEmitter();
  @Output('onShown') public onShown: EventEmitter<any> = new EventEmitter();
  @Output('onHide') public onHide: EventEmitter<any> = new EventEmitter();
  @Output('onHidden') public onHidden: EventEmitter<any> = new EventEmitter();

  /** This event fires as soon as content collapses */
  @Output() public collapsed: EventEmitter<any> = new EventEmitter();
  /** This event fires as soon as content becomes visible */
  @Output() public expanded: EventEmitter<any> = new EventEmitter();

  @Input() accordion: PmdCollapseAccordion;

  // @HostBinding('style.display') display: string;

  // shown
  // @HostBinding('class.show')
  // @HostBinding('attr.aria`-expanded')
  public isExpanded = true;

  // @HostBinding('attr.aria`-expanded') ariaborder: boolean;

  // hidden
  // @HostBinding('attr.aria-hidden')
  public isCollapsed = false;

  // stale state
  // @HostBinding('class.collapse')
  public isCollapse = true;

  // animation state
  // @HostBinding('class.collapsing')
  public isCollapsing = false;
  public collapsing = false;

  /** A flag indicating visibility of content (shown or hidden) */

  // @Input() public pmdCollapse: boolean;

  @Input()
  get pmdCollapse(): any {
    return this.isExpanded;
  }

  set pmdCollapse(value: any) {
    // if (typeof this.pmdCollapse !== 'undefined') {
    //   this.pmdCollapse = this.isExpanded;
    // } else {
    //   this.isExpanded = value;
    // }
    // if (value !== this.isExpanded) {

    // }
    if (value === '') {
      this.isExpanded;
    } else {
      this.isExpanded = value;
    }
    this.toggle();
  }

  @Input() public animationTime = 200;

  public maxHeight: number;

  protected _el: ElementRef;
  protected _renderer: Renderer2;

  public constructor(_el: ElementRef, _renderer: Renderer2) {
    this._el = _el;
    this._renderer = _renderer;
  }

  ngOnInit() {
    this._el.nativeElement.classList.add('show');
    this.maxHeight = this._el.nativeElement.scrollHeight;
    this._el.nativeElement.style.transition = this.animationTime + 'ms ease';
    // if (!this.pmdCollapse) {
    //   this.hide();
    // } else {
    //   this.show();
    // }
    // this.isExpanded = this.pmdCollapse;
  }

  ngOnDestroy(): any {
    this.removeGroup(this);
  }

  /** allows to manually toggle content visibility */
  toggle(): void {
    if (!this.collapsing) {
      // this.pmdCollapse = !this.pmdCollapse
      // console.log(this.pmdCollapse, "value collapsing");
      if (this.isExpanded) {
        this.hide();
        // console.log(this.pmdCollapse, "hide value collapsing");
      } else {
        this.show();
        // console.log(this.pmdCollapse, "show value collapsing");
      }
    }
  }

  /** allows to manually hide content */
  hide(): void {
    const container = this._el.nativeElement;
    this._renderer.setStyle(container, 'height', this._el.nativeElement.scrollHeight + 'px');
    this.collapsing = true;
    this.onHide.emit();
    this.isCollapse = false;
    this.isCollapsing = true;

    this.isExpanded = false;
    this.isCollapsed = true;

    setTimeout(() => {
      this._renderer.setStyle(container, 'height', '0px');
      container.classList.remove('collapse');
      container.classList.remove('show');
      container.classList.add('collapsing');
    }, 0);

    setTimeout(() => {
      container.classList.remove('collapsing');
      container.classList.add('collapse');
      this.onHidden.emit();
      this.collapsing = false;
    }, this.animationTime);

    this.removeGroup(this);

    this.collapsed.emit(this);
  }

  /** allows to manually show collapsed content */
  show(): void {
    if (!this.isExpanded) {
      this.collapsing = true;
      this.onShow.emit();
      this.isCollapse = false;
      this.isCollapsing = true;
      this.isExpanded = true;
      this.isCollapsed = false;

      const container = this._el.nativeElement;

      container.classList.remove('collapse');
      container.classList.add('collapsing');

      setTimeout(() => {
        this._renderer.setStyle(container, 'height', this._el.nativeElement.scrollHeight + 'px');
      }, 30);

      setTimeout(
        () => {
          container.classList.remove('collapsing');
          container.classList.add('collapse');
          container.classList.add('show');
          this.onShown.emit();
          this.collapsing = false;
        },
        this.animationTime - this.animationTime * 0.5
      );

      setTimeout(() => {
        this._renderer.removeStyle(container, 'height');
      }, this.animationTime + 20);

      this.closeOtherPanels(this);
      this.addGroup(this);

      this.expanded.emit(this);
    }
  }

  closeOtherPanels(openGroup: PmdCollapse): void {
    if (!this.accordion || !this.accordion.closeOthers) {
      return;
    }
    this.accordion.groups.forEach((group: PmdCollapse) => {
      if (group !== openGroup) {
        group.isCollapsed = true;
        group.hide();
      }
    });
  }

  addGroup(group: PmdCollapse): void {
    if (!this.accordion) {
      return;
    }
    this.accordion.groups.push(group);
  }

  removeGroup(group: PmdCollapse): void {
    if (this.accordion && this.accordion.groups.length > 0) {
      const index = this.accordion.groups.indexOf(group);
      if (index !== -1) {
        this.accordion.groups.splice(index, 1);
      }
    }
  }
}
